import { render } from "./EventNewsfeed.vue?vue&type=template&id=f1c91f16"
import script from "./EventNewsfeed.vue?vue&type=script&lang=js"
export * from "./EventNewsfeed.vue?vue&type=script&lang=js"

import "./EventNewsfeed.vue?vue&type=style&index=0&id=f1c91f16&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__